import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Button from "../components/Button";
import Filter from "../components/datatable/Filter";

const FILTER_OPTIONS = {
    all: {
        name:   'All',
        value:  'all',
    },
    survey: {
        name:   'Survey',
        value:  'survey',
    },
    quote: {
        name:   'Quote',
        value:  'quote',
    },
    order: {
        name:   'Order',
        value:  'order',
    },
    manufacture: {
        name:   'Manufacture',
        value:  'manufacture',
    },
    archived: {
        name:   'Archived',
        value:  'archived',
    },
}

const CustomerJobDataTable = ({ customerId }) => {
    const dataTableRef          = useRef(null);
    const [search, setSearch]   = useState("");
    const [filter, setFilter]   = useState(FILTER_OPTIONS.all.value);

    const renderRowButton = (job) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!job.can && job.can.view === true && (
                        <a className="text-primary cursor-pointer" href={route('job.show', {job: job.id}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card classes={"mh-100 border-0"} noPadding={!!customerId}>
                <div className={"row m-0 mb-4 p-0 d-flex justify-content-xl-between"}>
                    <div className="col-12 col-xl-6 m-0 mb-3 mb-xl-0 p-0 pl-xl-2 order-xl-2">
                        <div className={"d-flex justify-content-between justify-content-xl-end align-items-center"}>
                            <Filter
                                label={"Filter by Status:"}
                                value={filter}
                                options={Object.values(FILTER_OPTIONS)}
                                name={"filter_status"}
                                onChange={(value) => setFilter(value)}
                                classes={""}
                            />
                            {can('create', 'job') && (
                                <Button
                                    href={route('job.create', {customer_id: customerId, origin: "customer"}).toString()}
                                    label={"Create Job"}
                                    icon={"far fa-plus-circle"}
                                    classes={"ml-4 btn btn-eh-lilac px-3 m-0"}
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-12 col-xl-6 m-0 p-0 pr-xl-2 order-xl-1 d-flex justify-content-start align-items-center">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.customer.job.data-table', {customer: customerId}).toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="jobs" />}
                                fieldsToExclude={[
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldMap={{
                                    id:             "Job Reference",
                                    name:           "Name",
                                    site_name:      "Site",
                                    job_type_name:  "Type",
                                    contact_name:   "Main Contact",
                                    created_at:     "Created Date",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'id'}
                                defaultOrderByDirection={'asc'}
                                params={{
                                    searchTerm:     search,
                                    filterStatus:   filter
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'status':
                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default CustomerJobDataTable;

const target = document.getElementById('customer-jobs-datatable');
if (target) {
    const {
        customerId = null,
    } = target.dataset;
    ReactDOM.render(<CustomerJobDataTable customerId={customerId} />, target);
}
